import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import PasswordInput from '../PasswordInput';

const UserFormModal = ({ show, handleClose, handleSubmit, initialData }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [isStaff, setIsStaff] = useState(true);

    useEffect(() => {
        if (initialData) {
            setEmail(initialData.email || '');
            setIsActive(initialData.is_active ?? true);
            setIsStaff(initialData.is_staff ?? false);
            setPassword(''); // Reset password field for edits
        } else {
            // Reset for new user creation
            setEmail('');
            setPassword('');
            setIsActive(true);
            setIsStaff(true);
        }
    }, [initialData, show]);

    const onSubmit = (e) => {
        e.preventDefault();
        const userData = {
            email,
            is_active: isActive,
        };
        // In creazione il backend imposta sempre lo staff: il flag si invia solo in modifica
        if (initialData) {
            userData.is_staff = isStaff;
        }
        // Only include the password if it's being set (for creation or password change)
        if (password) {
            userData.password = password;
        }
        handleSubmit(userData);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{initialData ? 'Modifica Utente' : 'Crea Nuovo Utente'}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={onSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formUserEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Inserisci email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formUserPassword">
                        <Form.Label>Password</Form.Label>
                        <PasswordInput
                            placeholder={initialData ? 'Lascia vuoto per non cambiare' : 'Nuova Password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required={!initialData} // Password is required for new users
                            autoComplete="new-password"
                        />
                        <Form.Text className="text-muted">
                            Min. 8 caratteri, con maiuscole, minuscole, numeri e simboli.
                        </Form.Text>
                    </Form.Group>
                    <Form.Check
                        type="switch"
                        id="user-active-switch"
                        label="Utente Attivo"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                    {initialData && (
                        <Form.Check
                            className="mt-2"
                            type="switch"
                            id="user-staff-switch"
                            label="Staff (accesso a gestionale e contabilità)"
                            checked={isStaff}
                            onChange={(e) => setIsStaff(e.target.checked)}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Annulla
                    </Button>
                    <Button variant="primary" type="submit">
                        Salva
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UserFormModal;
